<template>
  <div class="view-member-area-modules-detail">
    <div v-if="loading" class="text-center fs-32 my-9">
      <b-spinner style="width: 3rem; height: 3rem;" variant="primary" />
    </div>
    <view-container
      v-else
      :title="moduleTitle"
      :subtitle="moduleSubtitle"
      header
      contentHeader
      :breadcrumbs="breadcrumbs"
    >
      <template #header>
        <div class="d-flex flex-row align-items-center justify-content-between">
          <product-dropdown v-if="product" :product="product" />
          <button
            v-if="product && product.is_blitz_members"
            class="btn btn-40 btn-link btn-new-link"
            @click="openClubLogged"
          >
            Acessar área de membros
            <i
              class="ml-5 fa-solid fa-arrow-up-right-from-square font-weight-bold"
            ></i>
          </button>
        </div>
      </template>
      <div class="view-member-area-modules pb-9">
        <div
          v-if="!allItems.length"
          class="container centering text-center pt-9"
        >
          <img
            class="d-block mb-9 mx-auto"
            src="@/assets/images/home/welcome.png"
          />
          <h5>Bem-vindo(a) a área de membros do seu produto</h5>
          <div class="text-secondary mb-9">
            Para começar, cadastre a primeira aula deste módulo.
          </div>
          <b-dropdown
            right
            offset="44"
            text="right align"
            class="btn btn-sm btn-40 btn-new-primary p-0"
          >
            <template #button-content>
              <div class="d-flex justify-content-between align-items-center">
                <span class="pr-5">Nova aula</span>
                <i class="icon-angle-down fs-16"></i>
              </div>
            </template>
            <b-dropdown-item>
              <router-link
                :to="{
                  name: 'product-members-lesson-add',
                  params: { id: $route.params.id },
                  query: { module_id: $route.params.module_id }
                }"
              >
                Nova aula em branco
              </router-link></b-dropdown-item
            >
            <b-dropdown-item @click="modal = true">
              Copiar aula existente
            </b-dropdown-item>
          </b-dropdown>
        </div>

        <template v-else>
          <div class="row justify-content-between pb-3">
            <div class="col-lg-5 py-5">
              <div class="d-flex align-items-center">
                <span class="text-accent-105">
                  Total: {{ allItems.length }}
                </span>
                <button
                  class="btn btn-sm btn-square-sm text-accent-105 font-weight-bold p-5"
                  @click="refresh"
                >
                  <i class="icon-refresh" />
                </button>
              </div>
            </div>
            <div class="col-lg-6 py-5">
              <div class="d-sm-flex align-items-center justify-content-end">
                <search-filter
                  class="flex-fill"
                  placeholder="Pesquisar"
                  v-model="search"
                  :showResultsDropdown="false"
                  size="md"
                />
                <div class="mx-3"></div>
                <div
                  class="d-flex align-items-center justify-content-end pt-5 pt-sm-0"
                >
                  <router-link
                    v-if="!module.parent"
                    class="btn btn-sm btn-40 btn-new-outline-primary px-3"
                    :to="{
                      name: 'product-members-submodule-add',
                      params: {
                        id: $route.params.id,
                        module_id: $route.params.module_id
                      }
                    }"
                  >
                    <i class="icon-plus pr-5"></i>
                    <span class="pr-5">Novo submódulo</span>
                  </router-link>
                  <div v-show="!module.parent" class="mx-3"></div>
                  <b-dropdown
                    right
                    text="right align"
                    class="btn btn-sm btn-40 btn-new-primary p-0"
                  >
                    <template #button-content>
                      <div
                        class="d-flex justify-content-between align-items-center"
                      >
                        <i class="icon-plus pr-5"></i>
                        <span class="pr-5">Nova aula</span>
                        <i class="icon-angle-down fs-16"></i>
                      </div>
                    </template>
                    <b-dropdown-item>
                      <router-link
                        :to="{
                          name: 'product-members-lesson-add',
                          params: { id: $route.params.id },
                          query: { module_id: $route.params.module_id }
                        }"
                      >
                        Nova aula em branco
                      </router-link>
                    </b-dropdown-item>
                    <b-dropdown-item @click="modal = true">
                      Copiar aula existente
                    </b-dropdown-item>
                  </b-dropdown>
                </div>
              </div>
            </div>
          </div>

          <div v-if="loading" class="text-center">
            <b-spinner variant="primary" />
          </div>

          <draggable-modules
            v-else-if="search.length"
            v-model="searchResults"
            group="search"
            @edit-module="editmodule"
            @edit-submodule="editSubmodule"
            @remove-module="removemodule"
            @remove-submodule="removesubmodule"
            @edit-lesson="editLesson"
            @remove-lesson="removelesson"
          />

          <template v-else>
            <draggable-items
              v-if="sortedItems.length"
              v-model="sortedItems"
              group="lessons"
              @duplicate-lesson="duplicateLesson"
              @edit-lesson="editLesson"
              @remove-lesson="removelesson"
              @duplicate-quizz="duplicateQuizz"
              @edit-quizz="editQuizz"
              @remove-quizz="removeQuizz"
            />
            <div class="mb-6"></div>
            <hr v-if="sortedSubmodules.length" class="mb-6" />
            <draggable-modules
              v-if="sortedSubmodules.length"
              v-model="sortedSubmodules"
              group="submodules"
              @duplicate-submodule="duplicateSubmodule"
              @edit-submodule="editSubmodule"
              @remove-submodule="removesubmodule"
            />
            <div class="mb-6"></div>
          </template>
        </template>
        <responsive-modal v-model="modal">
          <clone-lesson @close="() => (this.modal = false)" />
        </responsive-modal>
      </div>
    </view-container>
  </div>
</template>

<script>
import CloneLesson from "@/components/product/details/content/CloneLesson";
import DraggableItems from "@/components/product/details/content/DraggableItems";
import DraggableModules from "@/components/product/details/content/DraggableModules";
import ProductDropdown from "@/components/product/ProductDropdown.vue";
import ViewContainer from "@/components/ViewContainer.vue";
import { findIn } from "@/functions/helpers.js";
import MemberAreaMixin from "@/mixins/memberArea.js";
import ProductActionsMixin from "@/mixins/productActions.js";
import get from "lodash/get";
import { mapState } from "vuex";

export default {
  mixins: [ProductActionsMixin, MemberAreaMixin],
  components: {
    DraggableModules,
    ProductDropdown,
    DraggableItems,
    ViewContainer,
    CloneLesson
  },
  data() {
    return {
      params: {
        product_id: this.$route.params.id,
        offset: 0,
        limit: 1000,
        search: ""
      },
      loading: false,
      search: "",
      editedIndex: null,
      modal: false
    };
  },
  computed: {
    ...mapState("product", ["product"]),
    ...mapState("membersModules", ["modules", "module", "pagination"]),
    allItems() {
      return [...this.sortedItems, ...this.sortedSubmodules];
    },
    module_id() {
      return this.$route.params.module_id;
    },
    breadcrumbs() {
      return [
        { link: "product", title: "Meus produtos" },
        {
          link: "product-details",
          title: this.product ? this.product["name"] : "...",
          params: { id: this.$route.params.id }
        },
        {
          link: "product-member-area-modules",
          title: "Conteúdo",
          params: { id: this.$route.params.id }
        },
        {
          title: this.moduleTitle
        }
      ];
    },
    moduleTitle() {
      if (!this.module) return "Detalhes do Módulo";

      return this.module.name;
    },
    moduleSubtitle() {
      if (!this.module.parent) return "Cadastre submódulos e aulas";

      return "Cadastre aulas";
    },
    searchResults() {
      return [...this.sortedSubmodules, ...this.sortedItems].filter(item =>
        findIn(item, this.search)
      );
    },
    sortedSubmodules: {
      get() {
        return [...get(this.module, "sub_modules", [])].sort(
          (a, b) => a.sort - b.sort
        );
      },
      set(val) {
        const moduleClone = { ...this.module };
        for (let i in val) {
          val[i].sort = i;
        }
        moduleClone.sub_modules = val;

        this.$store.commit("membersModules/setModule", moduleClone);
        this.saveOrderSubModules();
      }
    },
    sortedItems: {
      get() {
        return [...get(this.module, "items", [])].sort(
          (a, b) => a.sort - b.sort
        );
      },
      set(val) {
        const moduleClone = { ...this.module };
        for (let i in val) {
          val[i].sort = i;
        }
        moduleClone.items = val;

        this.$store.commit("membersModules/setModule", moduleClone);
        this.saveOrderItems();
      }
    }
  },
  mounted() {
    this.dispatch();
    this.dispatchModules();
    this.getMemberAreaSetup();
  },
  methods: {
    reorderNested({ sub_modules, module }) {
      module.sub_modules = sub_modules;
      for (let i in sub_modules) {
        sub_modules[i].sort = i;
        sub_modules[i].parent = module.id;
      }
      this.saveOrder();
    },
    duplicateLesson(lesson) {
      this.$store
        .dispatch("membersLessons/duplicate", lesson.id)
        .then(() => this.refresh());
    },
    duplicateQuizz(item) {
      this.$store
        .dispatch("membersQuizzes/duplicate", item.id)
        .then(() => this.refresh());
    },
    duplicateSubmodule(module) {
      this.$store
        .dispatch("membersModules/duplicate", module.id)
        .then(() => this.refresh());
    },
    reorderLessons({ lessons, module }) {
      module.lessons = lessons;
      for (let i in lessons) {
        lessons[i].sort = i;
        lessons[i].module = module.id;
      }
      this.saveOrderItems();
    },
    getNewModuleList() {
      const modules = [...this.modules];
      const index = modules.findIndex(({ id }) => id == this.module.id);
      modules.splice(index, 1, this.module);
      return modules;
    },
    saveOrderSubModules() {
      const list = this.getNewModuleList();
      this.$store.dispatch(
        "membersModules/reorder",
        list.reduce((prev, curr) => [...prev, curr, ...curr.sub_modules], [])
      );
    },
    saveOrderItems() {
      this.$store.dispatch("membersModules/reorderItems", this.module.items);
    },
    onPaginationUpdate(offset) {
      this.params.offset = offset;
      this.refresh();
    },
    editmodule(module) {
      this.$router.push({
        name: "product-members-module-edit",
        params: {
          id: this.$route.params.id,
          module_id: module.id
        }
      });
    },
    editSubmodule(module) {
      this.$router.push({
        name: "product-members-submodule-edit",
        params: {
          id: this.$route.params.id,
          module_id: this.$route.params.module_id,
          submodule_id: module.id
        }
      });
    },
    removemodule(module) {
      this.$store
        .dispatch("membersModules/delete", module.id)
        .then(this.refresh);
    },
    removesubmodule(module) {
      this.$store
        .dispatch("membersModules/deleteSub", module.id)
        .then(this.refresh);
    },
    editLesson(lesson) {
      this.$router.push({
        name: "product-members-lesson-edit",
        params: {
          id: this.$route.params.id,
          lesson: lesson.id
        }
      });
    },
    editQuizz(item) {
      this.$router.push({
        name: "product-members-module-quizz-edit",
        params: {
          id: this.$route.params.id,
          module_id: this.$route.params.module_id,
          quizz_id: item.id
        }
      });
    },
    removelesson(lesson) {
      this.$store
        .dispatch("membersLessons/delete", lesson.id)
        .then(this.refresh);
    },
    removeQuizz(quiz) {
      this.$store
        .dispatch("membersQuizzes/delete", quiz.code)
        .then(this.refresh);
    },
    searching(v) {
      this.search = v;
    },
    refresh() {
      this.dispatch();
    },
    dispatch() {
      this.loading = true;
      this.$store.dispatch("product/getProduct", this.$route.params.id);
      this.$store
        .dispatch("membersModules/getDetails", this.$route.params.module_id)
        .finally(() => {
          this.loading = false;
        });
    },
    dispatchModules() {
      this.$store
        .dispatch("membersModules/get", {
          product_id: this.$route.params.id,
          offset: 0,
          limit: 1000
        })
        .then();
    }
  }
};
</script>

<style lang="scss" scoped>
.view-member-area-modules-detail {
  a {
    text-decoration: none;
  }

  .box {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border: 1px solid #d2d0d8;
    border-radius: 4px;
    height: 232px;
    cursor: pointer;
    img {
      height: 54px;
      width: 54px;
    }

    &:hover {
      background: linear-gradient(148.5deg, #ee6469 -19.31%, #9155ec 100%);
      border-color: rgb(191, 92, 170);

      strong {
        color: white;
      }
    }
  }

  .handle {
    cursor: grab;
  }

  .btn {
    white-space: nowrap;
  }

  .countStudents {
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: rgba(82, 0, 205, 0.9);
  }

  hr {
    border-top: 1px solid #f0eff2;
    border-radius: 8px;
  }
  ::v-deep .btn {
    &.dropdown-toggle {
      background-color: unset !important;
      min-height: 40px;
      padding: 0 16px;
      border: unset !important;

      &::after {
        content: none;
      }
    }
  }
  .dropdown-item {
    a {
      color: unset !important;
    }
  }
}
</style>
